const React = require("react");

function CodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
  }));
}

module.exports = CodeIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/CodeIcon.js
 ** module id = 488
 ** module chunks = 0
 **/